<template>
  <div>
    <Card
      v-for="result in searchResults"
      :key="result.personID">
      <template slot="header">
        {{ result.personID }}: {{ result.lastName }}, {{ result.firstName }}
      </template>
      <template slot="extras">
        <v-btn
          light
          @click="selectPerson(result)"
        >
          Select
        </v-btn>
      </template>
      <p>
        Email: {{ result.email }}<br>
        Phone: {{ result.phone1 }} or {{ result.phone1 }}<br>
        Company: {{ result.company }}<br>
        Emergency Contact: {{ result.emergencyContactName }} ({{ result.emergencyContactPhone }})<br>
        {{ result.address1 }}{{ result.address2 }} <br>
        {{ result.city }}, {{ result.state }}, {{ result.zip }} <br>
        {{ result. country }} <br>
      </p>
    </Card>
  </div>
</template>

<script>
// import components

// import vuex mapping
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Results',
  computed: {
    ...mapGetters({
      searchResults: 'person/searchResults'
    })
  },
  methods: {
    ...mapActions({
      setProxyPerson: 'person/setProxyPerson'
    }),
    selectPerson (person) {
      this.setProxyPerson(person)
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>
